import AbstractRepository from "@/repositories/AbstractRepository";

export default class ClientRepository extends AbstractRepository {
    protected static resource: string = "ptf-socle-client";

    protected static defaultFields: string[] = [
        "uuid",
        "moduleName",
        "mainKpi",
        "flatFeesAmount",
        "flatFeesDescription",
        "owner.uuid",
        "approvalRequired",
    ];
}
